<template>
    <div class="area-toggle">
        <div>{{inputLbl}}</div>
        <div class="">
            <img src="@/assets/icon/ic-toggle-inactive.svg" v-if="!content" @click="selectToggle()" />
            <img src="@/assets/icon/ic-toggle-active.svg" v-if="content" @click="selectToggle()" />
        </div>
    </div>
</template>
<script>
/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputToggle",
    props: {
        // v-model
        value:      Boolean,
        // text
        inputLbl:   String,
        all:        Boolean,
        email:      Boolean,
        sms:        Boolean,
        line:       Boolean
    },
    data: function() {
        return {
            content: true,
            customClass: '',
        };
    },
    watch: {
       value: function(val) {
           this.content = val;
       },
    },
    created: function() {
        this.customClass = this.addClass == null ? '' : this.addClass;
        this.content = this.value;
    },
    methods: {
        selectToggle: function() {
            this.content = !this.content;
            if (this.all) {
                this.$emit('onClickAll', this.content);
            } else if (this.email) {
                this.$emit('onAcceptEmail', this.content);
            } else if (this.sms) {
                this.$emit('onAcceptSMS', this.content);
            } else {
                this.$emit('onAcceptLine', this.content);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
.area-toggle {
    @extend %display-flex;
    justify-content: space-between;
    padding: {
        left: 25px;
        right: 25px;
        bottom: 15px;
    };
    font-size: 1.125rem;
    color: $black;
}
</style>
